module.exports = __webpack_public_path__ + "media/entities/1405-77fdfdaa.png";